// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2bd83cab","598":"15fbece5","787":"4979ef18"}[chunkId] + ".chunk.js";
};